export const IAM_SMART_FORM_DATA_KEY = 'dialogSignIASHKID';
